import { CONFIG, goToCheckout } from "../../config";
import { ArrowUpRight, Flame } from "lucide-react";
import { useI18n } from "../../i18n";

export default function FinalCTA() {
  const { t, currency, fmtCcy } = useI18n();
  return (
    <section className="relative py-20 sm:py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 grain opacity-40 pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] sm:w-[900px] h-[600px] sm:h-[900px] gold-ring rounded-full opacity-50 pointer-events-none" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="chip">
          <Flame className="w-3 h-3 text-[color:var(--gold)]" />
          {t("final_chip", { n: CONFIG.COPIES_LEFT })}
        </span>
        <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-7xl mt-5 sm:mt-6 leading-[1] tracking-tight">
          {t("final_h1_a")} <span className="text-[color:var(--gold)] glow-gold">{t("final_h1_b")}</span>
          <br />
          {t("final_h1_c")}
        </h2>
        <p className="text-[color:var(--ink-dim)] mt-5 sm:mt-6 text-sm sm:text-base lg:text-lg max-w-2xl mx-auto leading-relaxed">{t("final_sub")}</p>

        <div className="mt-8 sm:mt-10 flex flex-col items-center gap-3">
          <div className="flex items-baseline gap-3">
            <span className="text-xl sm:text-2xl lg:text-3xl line-through text-[color:var(--ink-mute)]">{fmtCcy(currency.mrp)}</span>
            <span className="font-display font-black text-5xl sm:text-6xl lg:text-7xl text-[color:var(--gold)] glow-gold">{fmtCcy(currency.price)}</span>
          </div>
          <span className="text-[10px] sm:text-xs font-mono uppercase tracking-widest px-3 py-1 rounded-full"
            style={{ background: "rgba(0,255,136,.1)", color: "var(--green)" }}>
            {t("final_save", { amount: fmtCcy(currency.mrp - currency.price) })}
          </span>
        </div>

        <button onClick={() => goToCheckout(currency.code, currency.price)} data-testid="final-cta"
          className="btn-gold mt-8 sm:mt-10 h-13 sm:h-14 px-7 sm:px-8 rounded-full inline-flex items-center gap-2 text-base font-display">
          {t("final_cta")} <ArrowUpRight className="w-5 h-5" />
        </button>

        <div className="mt-5 sm:mt-6 text-[11px] sm:text-xs text-[color:var(--ink-mute)]">{t("final_trust")}</div>
      </div>
    </section>
  );
}
